import { gql } from '@apollo/client';

export const bankInstitutionsQuery = gql`
  query {
    getBankInstitutions {
      bankInstitutionId
      bankInstitutionName
    }
  }
`;
